<section class="faq">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li
        class="breadcrumb-item"
        *ngFor="let item of breadCrumbItems; let last = last"
      >
        <ng-container *ngIf="!last">
          <a *ngIf="item.url; else noLink" [routerLink]="item.url">{{
            item.label | translate
          }}</a>
          <ng-template #noLink=""
            ><span class="with-link" (click)="clearFAQs()">{{
              item.label | translate
            }}</span></ng-template
          >
        </ng-container>
        <ng-container *ngIf="last">
          <span class="without-link">{{ item.label | translate }}</span>
        </ng-container>
      </li>
    </ol>
  </nav>

  <div *ngIf="caseId" class="cases-tabs-container">
    <mat-tab-group
      class="ignore-theme"
      [(selectedIndex)]="selectedCaseIndex"
      (selectedIndexChange)="selectCase(cases[$event].id)"
      mat-stretch-tabs="true"
    >
      <mat-tab
        *ngFor="let caseItem of cases; let i = index"
        [label]="caseItem.summary"
      >
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="gap-container">
    <div class="faq-content">
      <h4>{{ "FrequentlyAskedQuestions" | translate }}</h4>

      <app-search-input (onSearch)="searchChange($event)"></app-search-input>

      <ng-container *ngIf="!loading">
        <ng-container *ngIf="!showCases; else AlsoSearchByCasesTemplate">
          <div style="width: 100%">
            <div
              class="faq-content__categories"
              *ngFor="let category of faqsToShow | keyvalue"
            >
              <h5 class="faq-content__categories__title">
                {{ category.key | translate | titlecase }}
              </h5>
              <mat-accordion class="faq-content__questions__list">
                <mat-expansion-panel
                  class="faq-content__questions__list__item"
                  *ngFor="let faq of category.value"
                >
                  <mat-expansion-panel-header
                    class="faq-content__questions__list__item--header"
                  >
                    {{ faq.question }}
                  </mat-expansion-panel-header>
                  <markdown>
                    {{ faq.answer }}
                  </markdown>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>

        </ng-container>
        <ng-template #AlsoSearchByCasesTemplate>
          <div class="faq-cases-container">
            <p class="faq-cases-container__title">
              {{ "AlsoSearchByCases" | translate }}
            </p>

            <div class="faq-cases-container__list">
              <div
                class="faq-cases-container__list__item"
                *ngFor="let c of cases"
                (click)="selectCase(c.id)"
              >
                <p class="faq-cases-container__list__item__title">
                  {{ c.summary }}
                </p>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>

      <div *ngIf="loading" class="loading-container">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    </div>
  </div>
</section>
